"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.copySchema = void 0;
const language_model_1 = require("./language.model");
const yup_lib_1 = __importDefault(require("../yup-lib"));
exports.copySchema = yup_lib_1.default.object().shape({
    intent: yup_lib_1.default.string().required(),
    slot: yup_lib_1.default.string().required(),
    copy: yup_lib_1.default
        .array()
        .of(yup_lib_1.default
        .object({
        language: language_model_1.accountLanguageSchema,
        content: yup_lib_1.default.string().required()
    })
        .required())
        .required(),
    isFulfillment: yup_lib_1.default.boolean().required(),
    isGreeting: yup_lib_1.default.boolean().required()
});
